module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExtIt.52afd52.ttf";